/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BroadcastScheduleDto } from '../../models/broadcast-schedule-dto';

export interface BroadcastScheduleControllerFindAllV1$Params {

/**
 * 방송 상태 필터 (SCHEDULED, SHOOTING_DONE, AIRED, CANCELLED)
 */
  status?: 'SCHEDULED' | 'SHOOTING_DONE' | 'AIRED' | 'CANCELLED';
}

export function broadcastScheduleControllerFindAllV1(http: HttpClient, rootUrl: string, params?: BroadcastScheduleControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BroadcastScheduleDto>>> {
  const rb = new RequestBuilder(rootUrl, broadcastScheduleControllerFindAllV1.PATH, 'get');
  if (params) {
    rb.query('status', params.status, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BroadcastScheduleDto>>;
    })
  );
}

broadcastScheduleControllerFindAllV1.PATH = '/api/v1/broadcast-schedule';
